import React from 'react';

class Linkedin {
	welcome_pixel() {
        return null;
	}
}

export default new Linkedin();




// WEBPACK FOOTER //
// ./src/Linkedin.js